import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class TabsOption extends BaseOption {
  static userInterfaceComponent = {
    label: "Tabs",
    component: inspectorTools.TAB_PICKER,
    useCustomLabel: true,
  };

  static defaultValue = [];
}
